import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import NewEntries from 'src/pages/InsigthFactory/NewEntries';
import {
  reload,
  putUnity,
  getEntries,
  getUnidades,
  updateEntries,
  archivarEntries,
} from 'src/services/insightService';
import { swalMessages, permitsList } from 'src/constants';
import pagination from 'src/utils/pagination';
import swal from 'sweetalert';
import { Context } from '../../context/Contex';
import filterArray from '../../utils/filterArray';
import * as paths from '../../routes/paths';

const initialForm = {
  id: '',
  asunto: '',
  cuerpo: '',
};

const NewEntriesContainer = () => {
  const [postPerPage] = useState(5);
  const [units, setUnits] = useState([]);
  const [entries, setEntries] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [formEdit, setFormEdit] = useState(initialForm);
  const [tabSelect, setTabSelect] = useState(0);

  const history = useHistory();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];

  const getNewEntries = async () => {
    const { success, data } = await getEntries();
    if (success) {
      setEntries(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const getUnidadesNegocio = async () => {
    const { success, data } = await getUnidades();
    if (success) {
      setUnits(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  let allNewEntries = [];
  const filtedNewEntries = filterArray(entries, 'estado', '0');
  const filterArchived = filterArray(entries, 'estado', '1');
  const filterReject = filterArray(entries, 'estado', '4');
  allNewEntries = [...filtedNewEntries, ...filterReject];

  // Paginacion
  const onChangePage = (e, page) => {
    setCurrentPage(page);
  };
  const currentPostsEntries = pagination(allNewEntries, currentPage, postPerPage).currentPosts;
  const totalPagesEntries = pagination(allNewEntries, currentPage, postPerPage).totalPages;
  const currentPostArchived = pagination(filterArchived, currentPage, postPerPage).currentPosts;
  const totalpagesArchived = pagination(filterArchived, currentPage, postPerPage).totalPages;

  const handleChange = async (e, entryId) => {
    const unityName = e.target.name;
    swal(`¿Estás seguro de asignar a ${unityName}?`, { icon: 'warning', buttons: true }).then(async (willAccept) => {
      if (willAccept) {
        const idUnidadNegocio = e.target.value;
        const { success } = await putUnity({
          id: entryId,
          idUnidadNegocio,
          tipo: 'unidad_negocio',
        });
        if (success) {
          const updatedEntries = entries.filter((entry) => entry.id !== entryId);
          const currentEntries = currentPostsEntries.filter((entry) => entry.id !== entryId);
          setEntries(updatedEntries);
          swal(swalMessages.SUCCESFUL_UPDATE);
          if (currentEntries.length === 0) {
            setCurrentPage(1)
          }
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onClickArchive = (event, entryId) => {
    swal(swalMessages.ARCHIVE_CONFIRM).then(async (willArchive) => {
      if (willArchive) {
        const { success } = await archivarEntries({
          id: entryId,
          tipo: 'archivar',
        });
        if (success) {
          const updatedEntries = entries.map((entry) => {
            if (entry.id === entryId) {
              return {
                ...entry,
                estado: '1',
              };
            }
            return entry;
          });
          setTabSelect(1);
          setCurrentPage(1)
          setEntries(updatedEntries);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onClickUnarchive = (event, entryId) => {
    swal(swalMessages.UNARCHIVE_CONFIRM).then(async (willArchive) => {
      if (willArchive) {
        const { success } = await archivarEntries({
          id: entryId,
          tipo: 'desarchivar',
        });
        if (success) {
          const updatedEntries = entries.map((entry) => {
            if (entry.id === entryId) {
              return {
                ...entry,
                estado: '0',
              };
            }
            return entry;
          });
          setTabSelect(0);
          setCurrentPage(1)
          setEntries(updatedEntries);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onOpenEdit = (entry) => {
    setFormEdit(entry);
    setOpenEdit(true);
  };
  const onCloseEdit = () => {
    setOpenEdit(false);
  };

  const onChangeForm = (event, field) => {
    setFormEdit({
      ...formEdit,
      [field]: event.target.value,
    });
  };

  const onSubmitEdit = async (event) => {
    event.preventDefault();
    const { success } = await updateEntries({
      ...formEdit,
      tipo: 'actualizar',
    });
    if (success) {
      swal(swalMessages.SUCCESFUL_UPDATE);
      const updatedEntries = entries.map((entry) => {
        if (entry.id === formEdit.id) {
          return {
            ...entry,
            asunto: formEdit.asunto,
            cuerpo: formEdit.cuerpo,
          };
        }
        return entry;
      });
      setEntries(updatedEntries);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const withoutPermit = (permit) => {
    if (permit < 5) {
      history.push('/insight_factory');
    } else {
      return null;
    }
  };

  const onChangeTab = (event, value) => {
    setTabSelect(value);
    onChangePage(event, 1);
  };

  const reloadList = async () => {
    const { success } = await reload();
    if (success) {
      getNewEntries();
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onClickReturn = () => {
    history.push(paths.INSIGHT_FACTORY);
  };

  useEffect(() => {
    withoutPermit(permitValue);
    getNewEntries();
    getUnidadesNegocio();
  }, []);

  return (
    <NewEntries
      units={units}
      entries={entries}
      openEdit={openEdit}
      formEdit={formEdit}
      tabSelect={tabSelect}
      reloadList={reloadList}
      onOpenEdit={onOpenEdit}
      onChangeTab={onChangeTab}
      onCloseEdit={onCloseEdit}
      handleChange={handleChange}
      onChangeForm={onChangeForm}
      onSubmitEdit={onSubmitEdit}
      onChangePage={onChangePage}
      onClickArchive={onClickArchive}
      onClickUnarchive={onClickUnarchive}
      totalPagesEntries={totalPagesEntries}
      totalpagesArchived={totalpagesArchived}
      currentPostsEntries={currentPostsEntries}
      currentPostArchived={currentPostArchived}
      onClickReturn={onClickReturn}
    />
  );
};

export default NewEntriesContainer;
